export default __webpack_public_path__ + "3452e1de13c9225d3a5f7526a6cc3a5a.svg";